import { render, staticRenderFns } from "./tvs_team.vue?vue&type=template&id=4cf16cc6"
import script from "./tvs_team.vue?vue&type=script&lang=js"
export * from "./tvs_team.vue?vue&type=script&lang=js"
import style0 from "./tvs_team.vue?vue&type=style&index=0&id=4cf16cc6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports